<template>
    <div class="tablePage">
        <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            stripe
            border
            :header-cell-style="headCellStyle"
            :cell-style="bodyCellStyle"
            :height="tableHeight"
            :show-header="false"
            v-load-more.expand="{
                func: loadmore,
                target: '.el-table__body-wrapper',
                delay: 500
            }"
            :load-more-disabled="disabledLoad"
        >
            <el-table-column width="100px">
                <template #default="{ row }">
                    <div class="iconType">
                        <i :class="changeIcon(row.carrierTypeId)"></i>
                    </div>
                </template>
            </el-table-column>

            <el-table-column>
                <template #default="{ row }">
                    <div class="content">
                        <div class="rowContent">
                            <div class="letfContent">
                                <p>
                                    <span class="scopeClass span">{{ row.scopeName }}/</span>
                                    <span class="nodeClass span">{{ row.parentNodeName }}</span>
                                </p>
                                <p>
                                    <span class="span">{{ row.carrierName }}</span>
                                    <interHtmlVue :rowData="row" v-bind="$attrs" />
                                </p>
                            </div>
                            <div class="rightContent">
                                <p>{{ $t('integration.continued') }}:{{ getDiffDays(row) || ' ---' }}</p>

                                <p>
                                    {{ $t('public.table_create_time') }}:
                                    {{ $timetransition(row.happenTime) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="200px">
                <template #default="{ row }">
                    <div class="handlenumber">
                        <div class="processClass">
                            <span class="fs24" :title="$t('integration.processing_times_c__click_to_process_exception_records')" @click="handleFn(row)">{{ row.process }}</span>
                            <span class="pTime" v-show="row.process > 0">{{ $timetransition(row.processTime) }}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="200px">
                <template #default="{ row }">
                    <div class="closeIcon">
                        <div class="operateClass">
                            <i class="iconfont icon-close fs24" :class="row.status === 0 ? 'grey' : 'red100'" type="text" size="small" :title="row.status === 0 ? '未关闭异常' : '已关闭异常'"></i>
                            <span class="pTime" v-show="row.status === 1"> {{ $timetransition(row.closeTime) }}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <div slot="append" style="text-align: center" class="nomoreClass">
                {{ disabledLoadFn() }}
            </div>
        </el-table>
    </div>
</template>

<script>
import interHtmlVue from './interHtml.vue'

import { exProcess } from '@/api/modules/abnormal.js'
export default {
  props: ['tableData', 'disabledLoad', 'loading'],
  components: {
    interHtmlVue
  },
  data () {
    return {
      tableHeight: '100%',
      // 处理模态框
      isShow: false,
      title: '',
      handleQuery: {
        iDisplayStart: 0,
        iDisplayLength: 5,
        exId: null
      },
      choozeQuery: {
        iDisplayStart: 0,
        iDisplayLength: 5,
        exId: null,
        tab: 'link'
      },
      LinkparamData: [],
      ReasonparamData: [],
      resonArray: [],
      PowerparamData: [],
      rowData: {},
      active: '',

      // 数字处理框
      dialogLoading: false,
      total: 0
    }
  },

  methods: {
    loadmore () {
      if (this.$parent.SearchForm.iDisplayStart > 100) {
        this.$parent.SearchForm.iDisplayStart += 10
      } else {
        this.$parent.SearchForm.iDisplayStart = this.$parent.SearchForm.iDisplayLength + 10
      }
      this.$parent.SearchForm.iDisplayLength = 10
      this.$parent.getListFn()
    },
    disabledLoadFn () {
      return this.disabledLoad ? $t('integration.no_more') : $t('integration.scroll_to_the_bottom_to_load_more')
    },
    /** 点击异常图标 */
    handleClickIconFn (row) {
      this.handleQuery.exId = row.id
      exProcess(this.handleQuery).then(({ result }) => {})
    },
    /** 点击数字处理 */
    handleFn (row) {
      this.$emit('handleRow', row)
    },
    /** 表格勾选 */
    handleSelectionChange (arg) {
      this.$emit('choozeTable', [...arg])
    },
    /** 表格icon */
    changeIcon (num) {
      switch (num) {
        case 1: {
          return 'iconfont icon-weibolu-xian'
        }
        case 2: {
          return 'iconfont icon-bingxiang'
        }
        case 3: {
          return 'iconfont icon-qiche'
        }
        case 4: {
          return 'iconfont icon-9lengku'
        }
      }
    },
    /** 过滤类型 */
    FilterFn (num) {
      switch (num) {
        case 0: {
          return 'text.Temp-Ex'
        }
        case 1: {
          return 'device.conn_abnormal'
        }
        case 2: {
          return 'text.Hum-Ex'
        }
        case 3: {
          return 'device.conn_abnormal'
        }
      }
    },
    /** 持续时间 */
    getDiffDays (row) {
      const date1 = row.happenTime
      let date2 = new Date()
      if (row.status === 1) {
        date2 = row.closeTime
      }
      // 得到总秒数
      const ss = Math.abs(date2 - date1) / 1000
      // 得到天数
      const day = Math.floor(ss / 3600 / 24)
      // 得到不满一天的小时数
      const hour = Math.floor((ss / 3600) % 24)
      // 得到不满一小时的分钟数
      const minute = Math.floor((ss / 60) % 60)
      // 得到不满一分钟的秒数
      const second = Math.floor(ss % 60)
      if (day === 0 && hour === 0 && minute === 0) {
        return ''
      }
      return day + this.$t('text.Day') + hour + this.$t('text.hour') + minute + this.$t('text.min') + second + $t('public.second')
    },
    examine (row) {},
    handdispose (row) {},
    deleteDistory (row) {},
    handleLiFn () {},
    load () {}
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: 100%;
    overflow: hidden;

    .iconType,
    .handlenumber,
    .closeIcon {
        width: 100%;
        padding: 0 10px;
        line-height: 60px;
        box-sizing: border-box;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
    }

    .content {
        flex: 1;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .noMoreClass {
        text-align: center;
    }

    .active {
        background-color: #62fd5d;
    }

    .nomoreClass {
        height: 30px;
        margin-top: 15px;
    }
}

i {
    font-size: 32px;
    font-weight: bold;
}

.rowContent {
    height: 80px;
    display: flex;

    .letfContent {
        flex: 2;

        p {
            line-height: 30px;

            .span {
                color: var(--primary-color);
                font-weight: bold;
                font-size: 16px;
            }

            .scopeClass {
                color: var(--primary-color);
            }

            .nodeClass {
                color: #f8a72e;
            }
        }
    }

    .rightContent {
        flex: 1.1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;
    }

    i {
        cursor: pointer;
        color: #b4b4b4;
        font-size: 16px;
    }
}

.processClass {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;

    .pTime {
        line-height: 20px;
    }
}

.operateClass {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    .grey {
        color: #ccc;
    }

    .red100 {
        color: #ff3939;
    }

    .pTime {
        line-height: 20px;
    }
}

.fs24 {
    font-size: 32px;
    font-weight: bold;
    // line-height: 70px;
    cursor: pointer;
}
</style>
